import React from 'react';
import { Grid } from '@mui/material';

import { BooleanDescField, CurrencyTextField, TagsSelectField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function ContractsDetailsSectionSecondaryInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			{/* TAGS */}
			<Grid size={12}>
				<TagsSelectField
					name="cntr_tags"
					label={t('DETAILS_CONTRACTS_FIELD_TAGS')}
					value={props.model.cntr_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* WARNING */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<BooleanDescField
					name="cntr_warning_desc"
					label={t('DETAILS_CONTRACTS_FIELD_WARNING')}
					value={props.model.cntr_warning_desc}
					icon="alert-outline"
					color="warning.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* BLOCKED */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<BooleanDescField
					name="cntr_blocked_desc"
					label={t('DETAILS_CONTRACTS_FIELD_BLOCKED')}
					value={props.model.cntr_blocked_desc}
					icon="cancel"
					color="error.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* VALUE FIXED */}
			{/* <Grid size={{ sm: 6, xs: 12 }}>
				<CurrencyTextField
					name="cntr_value_fixed"
					label={t('DETAILS_CONTRACTS_FIELD_VALUE_FIXED')}
					value={props.model.cntr_value_fixed}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid> */}
		</>
	);
}
